import { Client } from "./client";
import { GetChildrenReply, PasteReply, PasteRequest } from "@/backend/express/controllers/treeController";

export class TreeController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  public async getChildren(id: string): Promise<GetChildrenReply> {
    return this.client.read(`/api/trees/${id}`);
  }

  public async pasteItem(request: PasteRequest): Promise<PasteReply> {
    return this.client.create(`/api/trees/paste`, request);
  }
}
